import { useEffect } from 'react';
import { totalUnread } from '@agrogruda/shared';
import { useWaConversations } from './api';

export const WA_NAV_BADGE_ID = 'waNavBadge';

/** Prototype waSyncBadge(): writes the unread total into the sidebar slot and hides it at 0. */
export function syncWaNavBadge(total: number, doc: Document = document): void {
  const badge = doc.getElementById(WA_NAV_BADGE_ID);
  if (!badge) return;
  badge.textContent = String(total);
  badge.classList.toggle('hidden', !total);
}

/** Keeps the sidebar slot `#waNavBadge` (rendered by the layout) in sync with a known unread total. */
export function useWaNavBadgeSync(total: number): void {
  useEffect(() => {
    syncWaNavBadge(total);
  }, [total]);
}

/** Live unread total (subscribes to the inbox realtime channel). */
export function useWaUnreadTotal(): number {
  const { conversations } = useWaConversations();
  return totalUnread(conversations);
}

/** Mount anywhere in the shell to keep the sidebar badge live on every page (renders nothing). */
export function WaNavBadgeSync(): null {
  useWaNavBadgeSync(useWaUnreadTotal());
  return null;
}
